/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Branch { 
    id?: number;
    name?: string | null;
    address?: string | null;
    code?: string | null;
    districtName?: string | null;
    regionName?: string | null;
    wardName?: string | null;
    numberOfEmployees?: number | null;
    tenantId?: number;
}

